import { getJobList } from './GetJobList';
import { getLikelyToFillExperiment } from './GetLikelyToFillExperiment';
import { getRecommendedRates, resolveRecommendedRate, resolveRateEntry } from './GetRecommendedRates';

/**
 * Jobs Service
 * Provides business logic layer for jobs operations
 */
export const JobsService = {
  getJobList,
  getLikelyToFillExperiment,
  getRecommendedRates,
};

export { resolveRecommendedRate, resolveRateEntry };
